module.exports = __webpack_public_path__ + "img/head1.d8576561.png";